// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjYjRqCn-UNWQrEJ5c7HG6ffxdRphKQpY",
  authDomain: "ledger-monkeys.firebaseapp.com",
  databaseURL: "https://ledger-monkeys-default-rtdb.firebaseio.com",
  projectId: "ledger-monkeys",
  storageBucket: "ledger-monkeys.appspot.com",
  messagingSenderId: "1032406172228",
  appId: "1:1032406172228:web:4593fe11b1cfd77f09f211"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export {auth, app}